export default "__VITE_ASSET__b934a045__"